import React, { HTMLAttributes } from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import clsx from "clsx";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {},
        title: {
            lineHeight: 1,
        },
    });
});

interface IProps extends HTMLAttributes<HTMLDivElement> {
    title?: string;
}

export default function ArticleTitle(props: IProps) {
    const { title, className, ...rest } = props;

    const classes = useStyles();

    return (
        <div className={clsx(className, classes.root)} {...rest}>
            {typeof title === "undefined" ? null : (
                <Typography variant="h4" className={classes.title}>
                    {title}
                </Typography>
            )}
        </div>
    );
}
